export default __webpack_public_path__ + "static/media/blueLineHamburger.70c8b906.svg";